import { useState, useEffect } from "react";
import './Menu.css';
import { useBotStateContext } from "../../../contexts/BotContext";
import BotService from "../../../../chatbox/actions/ConversationAction";
import { env } from '../../../../../var/env'
import useShiftKey from "../../../hook/useShiftKey";
import storage from "/src/utils/storage";
import { useTreeStateContext } from "../../../contexts/TreeContext";

import useBlockMenu from "../../../hook/block/useBlockMenu";
// Component right menu for action delete/export/update on the bot
function Menu({ className, id, deletable }) {


    const { blocks } = useTreeStateContext();

    const { botId, onUpdate } = useBotStateContext()

    const { askBotNextQuestion } = BotService();

    const { shiftKey } = useShiftKey();

    const { onClickPlay, onClickDuplicate, onClickJump, onClickDelete,onClickDeleteFromCategory,getCategory,show, setShow, onClick, setOnClick } = useBlockMenu(id);

    const category = getCategory();

    useEffect(() => {
        if (onClick != true || onUpdate != false) return;
        askBotNextQuestion(id)
        setOnClick(false);
    }, [onUpdate, onClick])
    return (
        <div className={"more_btn " + className} onMouseOver={() => shiftKey == false && setShow(true)} onMouseLeave={(e) => e.target.class != "block_context_menu" && setShow(false)}>
            {
                show &&

                <div className={"block_context_menu" + (category ? " context_with_category" : "")} onMouseLeave={() => shiftKey == false && setShow(false)}>
                    <div className="context_element play" onClick={onClickPlay}>Test</div>
                    {className == 'scenario' && <div className="context_element export"><a href={env.REACT_APP_API_PATH + `/bot/${botId}/scenario/${id}/export?token_auth=${storage('local').get('token')}&company=${storage('session').get('company').id}`} rel="noopener noreferrer">Export</a></div>}
                    {className != 'scenario' && <div className="context_element duplicate" onClick={()=>onClickDuplicate()}>Duplicate</div>}
                    {className == 'scenario' && <div className="context_element jump" onClick={()=>onClickJump()}>Jump</div>}

                    {
                        blocks && category &&
                        <div className="context_element_lockable" style={{ display: "flex", alignItems: "center" }}>
                            <div className={"context_element substract_category" + (category.locked ? " lock" : "")} onClick={onClickDeleteFromCategory} disabled={category.locked}>Ungroup</div>
                            {category.locked == true && <i className="fas fa-lock category_locked_element" style={{color : category.color}}></i>}
                            
                        </div>

                    }
                      <div className="context_element_lockable" style={{ display: "flex", alignItems: "center" }}>
                            <div className={"context_element delete " + (!deletable  || category?.locked ? "lock" : "")}  onClick={() => onClickDelete(className,deletable)} disabled={category?.locked}>Delete</div>
                            { (deletable   && category?.locked) ? <i className="fas fa-lock category_locked_element" style={{color : category.color}}></i> : ""}
                            </div>
                </div>
            }
        </div>
)
}

Menu.defaultProps = {
    deletable: true
}

export default Menu;